/**
 * CronoFormModal — crea / modifica un cronoprogramma.
 * Estratto da CantiereGanttView.jsx per contenere la complessità.
 */
import React from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/api";
import { GanttInput as Input } from "./ganttConstants";

export default function CronoFormModal({ cantiereId, onClose, qc, existing }) {
  const isEdit = !!existing;
  const [form, setForm] = React.useState({
    nome: existing?.nome || "",
    descrizione: existing?.descrizione || "",
    versione: existing?.versione || "1.0",
    data_inizio_prevista: existing?.data_inizio_prevista || "",
    data_fine_prevista: existing?.data_fine_prevista || "",
    responsabile: existing?.responsabile || "",
    stato: existing?.stato || "bozza",
    note: existing?.note || "",
    add_to_calendar: false,
  });
  const save = useMutation({
    mutationFn: (p) => {
      if (isEdit) return api.patch(`/cronoprogramma/cronoprogrammi/${existing.cronoprogramma_id}`, p).then((r) => r.data);
      return api.post("/cronoprogramma/cronoprogrammi", { ...p, cantiere_id: cantiereId }).then((r) => r.data);
    },
    onSuccess: () => {
      toast.success(isEdit ? "Cronoprogramma aggiornato" : "Cronoprogramma creato");
      qc.invalidateQueries({ queryKey: ["cronoprogrammi", cantiereId] });
      onClose();
    },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-md shadow-2xl w-full max-w-lg max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="crono-modal">
        <div className="p-4 border-b border-slate-200">
          <h3 className="font-display font-bold">{isEdit ? "Modifica cronoprogramma" : "Nuovo cronoprogramma"}</h3>
        </div>
        <div className="p-4 space-y-3 text-sm">
          <Input label="Nome" testid="input-nome" value={form.nome} onChange={(v) => setForm({ ...form, nome: v })} />
          <div>
            <label className="text-xs font-semibold text-slate-600 block mb-1">Descrizione</label>
            <textarea rows="2" value={form.descrizione} onChange={(e) => setForm({ ...form, descrizione: e.target.value })} className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Input label="Versione" value={form.versione} onChange={(v) => setForm({ ...form, versione: v })} />
            <Input label="Responsabile" value={form.responsabile} onChange={(v) => setForm({ ...form, responsabile: v })} />
            <Input label="Inizio previsto" type="date" value={form.data_inizio_prevista} onChange={(v) => setForm({ ...form, data_inizio_prevista: v })} />
            <Input label="Fine prevista" type="date" value={form.data_fine_prevista} onChange={(v) => setForm({ ...form, data_fine_prevista: v })} />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600 block mb-1">Stato</label>
            <select value={form.stato} onChange={(e) => setForm({ ...form, stato: e.target.value })} className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm bg-white">
              <option value="bozza">Bozza</option>
              <option value="attivo">Attivo</option>
              <option value="archiviato">Archiviato</option>
            </select>
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600 block mb-1">Note</label>
            <textarea rows="2" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm" />
          </div>
        </div>
        <div className="p-4 border-t border-slate-200 flex justify-end gap-2 bg-slate-50">
          <button onClick={onClose} className="px-4 py-2 text-sm border border-slate-300 rounded-sm hover:bg-white">Annulla</button>
          <button onClick={() => save.mutate(form)} disabled={save.isPending || !form.nome} data-testid="btn-save-crono" className="px-4 py-2 text-sm bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white font-semibold rounded-sm">{save.isPending ? "…" : "Salva"}</button>
        </div>
      </div>
    </div>
  );
}
